export const googleSocialLinkConstants = {
  STORE_DATA: "STORE_DATA",
  UPDATE_GOOGLE_SOCIAL_LINK: "UPDATE_GOOGLE_SOCIAL_LINK",
  GOOGLE_SOCIAL_LINK_LIMIT_ERROR:
    "Google Social Link cannot exceed 1000 characters",
  MAX_GOOGLE_SOCIAL_LINK_LENGTH: 1000,
};
